/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrentUserResponse
 */
export interface CurrentUserResponse {
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponse
     */
    userCode: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponse
     */
    counselorId: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurrentUserResponse
     */
    roles: Array<string>;
}

/**
 * Check if a given object implements the CurrentUserResponse interface.
 */
export function instanceOfCurrentUserResponse(value: object): value is CurrentUserResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userCode' in value) || value['userCode'] === undefined) return false;
    if (!('counselorId' in value) || value['counselorId'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function CurrentUserResponseFromJSON(json: any): CurrentUserResponse {
    return CurrentUserResponseFromJSONTyped(json, false);
}

export function CurrentUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'userCode': json['userCode'],
        'counselorId': json['counselorId'],
        'roles': json['roles'],
    };
}

export function CurrentUserResponseToJSON(json: any): CurrentUserResponse {
    return CurrentUserResponseToJSONTyped(json, false);
}

export function CurrentUserResponseToJSONTyped(value?: CurrentUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userCode': value['userCode'],
        'counselorId': value['counselorId'],
        'roles': value['roles'],
    };
}

